import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const AdsTagsService = {
  // Get tags with search filter
  searchTags: async (search = "") => {
    try {
      const params = new URLSearchParams();
      if (search && search.trim()) {
        params.append("search", search.trim());
      }

      const queryString = params.toString();
      const response = await apiService.get(
        `/itouch/ads-tags${queryString ? "?" + queryString : ""}`
      );
      return response.data || [];
    } catch (error) {
      console.error("Error searching tags:", error);
      return [];
    }
  },
};

export default AdsTagsService;
